import { render, staticRenderFns } from "./tds.vue?vue&type=template&id=34fb09c8&scoped=true"
import script from "./tds.vue?vue&type=script&lang=js"
export * from "./tds.vue?vue&type=script&lang=js"
import style0 from "./tds.vue?vue&type=style&index=0&id=34fb09c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb09c8",
  null
  
)

export default component.exports